<div class="row h-100">
  <div class="col scroll-container px-0">
    <main class="pt-4">
      <router-outlet></router-outlet>
    </main>
    <app-universal-footer></app-universal-footer>
  </div>
</div>
